import { ID } from 'shared/types/id';

/**
 * Resolves the original task ID from a virtual tree ID.
 * Handles IDs like "occurrence:2023-01-01:taskId"
 */
export const getTaskIdFromTreeId = (id: ID): ID => {
  const idStr = id.toString();
  if (idStr.startsWith('occurrence:')) {
    const parts = idStr.split(':');
    return parts[2];
  }
  return id;
};
